<div class="overlay">
  <div class="top-left">
    <select class="schrift" id="seite" (change)="onSubTypeDropDownSelect($event)">
      <option value="gesamt">Gesamtscore</option>
      <option value="duebel">Dübel</option>
    </select>
    <div class="top-center">
      <div>
        <app-point-style [side]="'links'"></app-point-style><span class="schrift">links</span>
        <span class="gap"></span>
        <app-point-style [side]="'rechts'"></app-point-style><span class="schrift">rechts</span>
      </div>
    </div>
  </div>

  <div class="top-right">
    <span class="schrift">Erfüllung</span>
  </div>
</div>
<canvas style="width: 100%" #canvas [id]="chartId">{{ chart }}</canvas>
